module.exports = __webpack_public_path__ + "img/Medientechnologe_EFZ_FP_010.22e9b340.jpg";